"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactIntl = require("react-intl");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _without = _interopRequireDefault(require("lodash/without"));

var _Button = _interopRequireDefault(require("@cimpress/react-components/lib/Button"));

var _conditionEditor = _interopRequireDefault(require("./conditionEditor"));

var _propTypes2 = require("./propTypes");

var _commonStyles = require("./commonStyles");

var _messages = _interopRequireDefault(require("./messages"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

var PredicateEditor = function PredicateEditor(props) {
  var conditions = props.conditions,
      results = props.results,
      attributes = props.attributes,
      addCondition = props.addCondition,
      updateCondition = props.updateCondition,
      removeCondition = props.removeCondition,
      formatMessage = props.intl.formatMessage;
  var usedOptions = [].concat(_toConsumableArray(conditions), _toConsumableArray(results)).map(function (condition) {
    return condition.attribute;
  }).filter(function (c) {
    return c;
  });

  var remainingOptions = _without["default"].apply(void 0, [Object.keys(attributes)].concat(_toConsumableArray(usedOptions)));

  return (
    /*#__PURE__*/
    _react["default"].createElement("div", null, conditions.map(function (condition, i) {
      return (
        /*#__PURE__*/
        _react["default"].createElement(_react.Fragment, {
          key: condition.attribute || i
        },
        /*#__PURE__*/
        _react["default"].createElement(_conditionEditor["default"], {
          style: _commonStyles.tenPxMarginTop,
          condition: condition,
          conditions: conditions,
          results: results,
          attributes: attributes,
          updateCondition: updateCondition,
          removeCondition: removeCondition
        }), i < conditions.length - 1 &&
        /*#__PURE__*/
        _react["default"].createElement("hr", null))
      );
    }), !conditions.length &&
    /*#__PURE__*/
    _react["default"].createElement("div", null,
    /*#__PURE__*/
    _react["default"].createElement("div", {
      className: "text-muted h5"
    }, formatMessage(_messages["default"].noConditionsAddToStart))),
    /*#__PURE__*/
    _react["default"].createElement(_Button["default"], {
      type: "default",
      className: _commonStyles.tenPxMarginTop,
      onClick: addCondition,
      disabled: !remainingOptions.length
    }, formatMessage(_messages["default"].addCondition)))
  );
};

PredicateEditor.propTypes = {
  conditions: _propTypes["default"].arrayOf(_propTypes["default"].shape({})),
  results: _propTypes["default"].arrayOf(_propTypes["default"].shape({})),
  attributes: _propTypes["default"].objectOf(_propTypes["default"].oneOfType([_propTypes["default"].shape(_propTypes2.optionShape), _propTypes["default"].shape(_propTypes2.propertyConditionAttributeShape)])).isRequired,
  addCondition: _propTypes["default"].func.isRequired,
  updateCondition: _propTypes["default"].func.isRequired,
  removeCondition: _propTypes["default"].func.isRequired,
  intl: _propTypes["default"].shape(_propTypes2.intlShape).isRequired
};
PredicateEditor.defaultProps = {
  conditions: [],
  results: []
};

var _default = (0, _reactIntl.injectIntl)(PredicateEditor);

exports["default"] = _default;